import Modal from "react-bootstrap/Modal";

export default function OrderModal({ show, onHide, lang, children }) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      dialogClassName="order-modal-modern"
    >
      <Modal.Header
        closeButton
        style={{
          border: "none",
          backgroundColor: "red",
          borderRadius: "1.5rem 1.5rem 0 0",
          boxShadow: "none",
        }}
      >
        <Modal.Title
          style={{
            fontWeight: 800,
            fontSize: "1.5rem",
            letterSpacing: "0.01em",
            color: "#fff",
          }}
        >
          {lang === "en" ? "Order Online" : "Encomende Online"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          gap: "2rem",
          background: "linear-gradient(90deg, #fff 0%, #e9ecef 100%)",
          borderRadius: "0 0 1.5rem 1.5rem",
          boxShadow: "0 8px 32px 0 rgba(217, 4, 41, 0.10)",
          padding: "2.5rem 2rem",
        }}
      >
        {children}
      </Modal.Body>
    </Modal>
  );
}
